const passwordRegex = /^(?=.*[a-z])(?=.*[0-9]).{8,}$/;

export default passwordRegex;
